import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import PageLayoutTypesMenuItem from '../components/PageLayoutTypesMenuItem';
import TypesDropdown from '../components/TypesDropdown';
import useQuery from '../../modules/react/hooks/useQuery';

const GET_TYPES = gql`
  query GetPageLayoutTypesDropdownData($localeCode: String!) {
    currentSite {
      id
      pageTypes {
        id
        ...TypesDropdownPageType
        ...PageLayoutTypesMenuItemPageType
      }
      siteType {
        id
        ...TypesDropdownSiteType
        ...PageLayoutTypesMenuItemSiteType
      }
    }
  }

  ${TypesDropdown.fragments.pageType}
  ${PageLayoutTypesMenuItem.fragments.pageType}
  ${TypesDropdown.fragments.siteType}
  ${PageLayoutTypesMenuItem.fragments.siteType}
`;

const propTypes = {
  localeCode: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
};

const defaultProps = {};

const PageLayoutTypesDropdown = ({ localeCode, typeId }) => {
  const { data } = useQuery(
    GET_TYPES,
    { variables: { localeCode }, ssr: false },
  );

  if (!data) {
    return null;
  }

  const { currentSite: { pageTypes, siteType } } = data;
  const types = [siteType, ...pageTypes];
  const type = types.find(potentialType => potentialType.id === typeId);

  return (
    <TypesDropdown
      advanced
      componentClass={PageLayoutTypesMenuItem}
      localeCode={localeCode}
      title="Layout Types"
      type={type}
      types={types}
    />
  );
};

PageLayoutTypesDropdown.propTypes = propTypes;
PageLayoutTypesDropdown.defaultProps = defaultProps;

export default PageLayoutTypesDropdown;
